import React, { useEffect } from "react";
import Orders from "./orders";
import * as providerActionCreators from "../load-build/orders/actions";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { Header, ThemeProvider } from "@deere/fuel-react";

const Forwarder = (props) => {
  const { load } = bindActionCreators(providerActionCreators, useDispatch());

  //load all providers
  useEffect(function () {
    load();
  }, []);

  return (
    <div className="container-fluid min-h-[350px]">
      <div className="rounded-xl mx-2 border-2 border-solid border-gray-400" >
        <Orders></Orders>
      </div>
    </div>
  );
};

export default Forwarder;
